import styled from 'styled-components';

import NotFound from '@components/NotFound';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const NotFoundPage: React.FC = () => {
  return (
    <Container>
      <NotFound />
    </Container>
  );
};

export default NotFoundPage;
